import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApModalResult, ApFileUploadModalService } from 'webcommon/core-ui';
import { FindControlUIBehaviorDto } from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})
export class ApFindControlImportModalService {
  constructor(
    private readonly apFileUploadModalService: ApFileUploadModalService,
  ) {
  }

  openModal(findControlBehavior: FindControlUIBehaviorDto): Observable<ApModalResult<File>> {
    const title = `Import ${findControlBehavior.Name}`;
    const message = `You have selected to import a ${findControlBehavior.Name}. Please select the XML containing its definition.`;
    const allowedExtensions = '.xml';
    return this.apFileUploadModalService.openModal(title, message, allowedExtensions);
  }
}
